import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { ForgotPasswordForm } from "../Components/custom/ForgotPasswordForm";
import { getDomainConfig } from "../Utils/dynamicBranding";

export const ForgotPassword = () => {
  useEffect(() => {
    // Set page title dynamically based on domain
    const config = getDomainConfig();
    document.title = `Forgot Password - ${config.title}`;
  }, []);

  return (
    <>
      <Box
        // height="100vh"
        display="flex"
        paddingTop="5rem"
        justifyContent="center"
      >
        <ForgotPasswordForm />
      </Box>
    </>
  );
};